import axios from 'axios';
import type { LearningStreak } from '@/app/track/utils/streakTypes';
import { EMPTY_STREAK } from '@/app/track/utils/streakTypes';
import { applyCompletionEffects } from '@/utils/learningEvents';

export { STREAK_UPDATED_EVENT, dispatchStreakUpdate } from '@/utils/learningEvents';

export async function fetchLearningStreak(token: string): Promise<LearningStreak> {
  const response = await axios.post(`${process.env.NEXT_PUBLIC_BASE_URL}/api/learn/streak`, {
    token,
  });
  return (response.data ?? EMPTY_STREAK) as LearningStreak;
}

export async function recordLearningActivity(
  token: string,
  activityType: 'question' | 'lesson' | 'flashcard' | 'exam' | 'vocabulary'
): Promise<LearningStreak | null> {
  try {
    const response = await axios.post(`${process.env.NEXT_PUBLIC_BASE_URL}/api/learn/record-activity`, {
      token,
      activityType,
    });
    applyCompletionEffects({
      streak: response.data?.streak,
      xp: response.data?.xp,
    });
    return (response.data?.streak ?? null) as LearningStreak | null;
  } catch {
    return null;
  }
}
